<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-lg.font-medium Are you sure you want to complete the visitation?
      v-spacer
    v-divider
    div.py-6.px-10
      div.neutral700--text You have not yet received full payment for this visit. Are you sure you want to complete the visitation?
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="$emit('confirm')" :loading="loading" color="neutral700" depressed dark) {{ $t('confirm') }}
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    }
  },
}
</script>